export const dataFieldsProduction = {
  Procedimento: 'procedimento',
  CBO: 'cbo',
  Quantidade: 'quantidade',
}
export const dataFieldsMeta = {
  Categoria: 'categoria',
  Meta: 'meta',
  Produção: 'quantidade',
}
export const dataFieldsProfessional = {
  Profissional: 'no_profissional',
  Produção: 'quantidade',
  Categoria: 'categoria',
}

export const infoHtml = ``
